import { Avatar, Box, ListItemButton, Tooltip, Typography } from '@mui/material'
import _ from 'lodash'
import React from 'react'
import UsersManager from '../../../managers/UsersManager'
import { useAppDispatch } from '../../../store/Hooks'
import { changeRoute } from '../../../store/slices/SessionSlice'

const LeftSettings: React.FC = () => {
    const dispatch = useAppDispatch()
    const currentUser = UsersManager.getCurrentUser()

    return (
        <ListItemButton
            sx={{
                width: '100%',
                flex: 1,
                flexDirection: 'row',
                justifyContent: 'center',
                borderRadius: 2,
                padding: 0 }}

            onClick={() => {
                dispatch(changeRoute({ route: 'user-profile' }))
            }}>
            <Box
                width='90%'
                display='flex'
                flexDirection='row'
                alignItems='center'
                gap={1}
                height='calc(var(--unit)*10)'>
                <Avatar src={(currentUser)?.image} alt={currentUser?.fullName || 'User'} />
                <Box flex={1}>
                    <Box>
                        <Typography variant='body1'>{currentUser ? _.truncate(currentUser.fullName, { length: 16 }) : 'Missing User'}</Typography>
                    </Box>
                    <Box>
                        <Tooltip title={currentUser?.email || 'N/A'} placement='bottom' enterDelay={1000}>
                            <Typography variant='caption' color='text.secondary'>
                                {currentUser ? _.truncate(currentUser.email, { length: 22 }) : 'N/A'}
                            </Typography>
                        </Tooltip>
                    </Box>
                </Box>
            </Box>
        </ListItemButton>

    )
}

export default LeftSettings
